import { useEffect } from 'react';
import ScriptLoader from 'react-script-loader-hoc';

import env from 'consts/env';
import { UserType } from 'store/modules/auth/auth';

export interface WindowWithHubSpot extends Window {
  _hsq: any;
}

interface HubSportScriptLoaderProps {
  scriptsLoaded: true;
  scriptsLoadedSuccessfully: true;
  userData: UserType;
}

const HubSportScriptLoader = ({
  scriptsLoadedSuccessfully,
  userData,
}: HubSportScriptLoaderProps) => {
  const identifyVisitor = () => {
    const _hsq = (((window as Window) as WindowWithHubSpot)._hsq =
      ((window as Window) as WindowWithHubSpot)._hsq || []);

    _hsq.push([
      'identify',
      {
        first_name: userData.first_name,
        email: userData.email,
        uuid: userData.uuid,
        username: userData.username,
      },
    ]);
  };

  useEffect(() => {
    if (scriptsLoadedSuccessfully) {
      identifyVisitor();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scriptsLoadedSuccessfully]);

  return null;
};

// Missing Types for react-script-loader-hoc
// @ts-ignore: Unreachable code error
export default ScriptLoader(`//${env.HUBSPOT}`)(HubSportScriptLoader);

// TODO:
// Add types for react-script-loader-hoc
